import { render, staticRenderFns } from "./index.vue?vue&type=template&id=610a59e1&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=610a59e1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a59e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610a59e1')) {
      api.createRecord('610a59e1', component.options)
    } else {
      api.reload('610a59e1', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=610a59e1&scoped=true&lang=pug", function () {
      api.rerender('610a59e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/newYear2024/index.vue"
export default component.exports